import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ReportsDashboard from './ReportsDashboard'

export default function Settings() {
	return (
		<React.Fragment>
			<Switch>
                <Redirect exact from="/reports" to="/reports/appointments" />
				<Route exact path="/reports/appointments" component={ReportsDashboard} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}